module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8003.b84bc178.png";